module.exports = __webpack_public_path__ + "static/media/S1_00002.d81de924.jpg";